import { isWorkshopParentFrontend } from '@/config';
import { Status } from '@/generated/GeneratedApiTypes';
import { STATUS } from './constants';

export const ENGINE_OIL_OUTDATED_HOURS = 24;

export const isEngineOilOutdated = (
    timestamp: string | undefined,
    hoursToBeOutdated: number = ENGINE_OIL_OUTDATED_HOURS,
): boolean => {
    if (!timestamp) return true;
    const diffInHours = (Date.now() - new Date(timestamp).getTime()) / (1000 * 60 * 60);
    return diffInHours > hoursToBeOutdated;
};

export const getThresholdClass = (
    status: Status,
    isReadingNotPossible: boolean = false,
    hasActiveDtc: boolean = false,
): string => {
    // An active DTC is always critical, so it must surface as danger even when the latest
    // reading is outdated / preconditions are not met. A level-derived DANGER (e.g. a critical
    // reading) is unreliable once outdated, so it falls through to the neutral state below.
    if (hasActiveDtc) return 'danger';
    if (isReadingNotPossible || status === STATUS.UNKNOWN) return isWorkshopParentFrontend() ? '' : 'default';
    if (status === STATUS.DANGER) return 'danger';
    if (status === STATUS.WARNING) return 'warning';
    if (status === STATUS.NORMAL) return '';
    return '';
};

export const getBarColorClass = (
    status: Status,
    isReadingNotPossible: boolean = false,
    hasActiveDtc: boolean = false,
): string => {
    // An active DTC is always critical, so it must surface as danger even when the latest
    // reading is outdated / preconditions are not met. A level-derived DANGER (e.g. a critical
    // reading) is unreliable once outdated, so it falls through to the neutral state below.
    if (hasActiveDtc) return 'progress-bar-danger';
    if (isReadingNotPossible || status === STATUS.UNKNOWN) return 'progress-bar-gray';
    if (status === STATUS.DANGER) return 'progress-bar-danger';
    if (status === STATUS.WARNING) return 'progress-bar-warning';
    if (status === STATUS.NORMAL) return 'progress-bar';
    return 'progress-bar-gray';
};

export const getIconName = (status: Status): string | undefined => {
    if (status === STATUS.DANGER) return 'icon-error-sign';
    if (status === STATUS.WARNING) return 'icon-warning-sign';
    if (status === STATUS.NORMAL) return 'icon-ok';
    return undefined;
};

export const getIconColor = (status: Status): string => {
    if (status === STATUS.DANGER) return 'text-color-danger';
    if (status === STATUS.WARNING) return 'text-color-warning';
    if (status === STATUS.NORMAL) return 'text-color-darkest';
    return 'text-color-gray';
};

const MODEL_YEAR_2022 = 2022;

export const isVehicleModelOlderThan2022 = (modelYear: string | null | undefined): boolean =>
    modelYear != null && parseInt(modelYear.substring(0, 4), 10) < MODEL_YEAR_2022;
